import { render, staticRenderFns } from "./LabelStatementsArchivingDialog.vue?vue&type=template&id=5abaf10d"
import script from "./LabelStatementsArchivingDialog.vue?vue&type=script&lang=js"
export * from "./LabelStatementsArchivingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports